﻿import type { IApiMediaWithCropsModel } from "#/_generated/umbraco/delivery-api/models";
import { getLocalizedStringFromJson } from "#/_packages/umbrella/utils/index.ts";
import { getLocale } from "#/paraglide/runtime";

export function getAltText(image: IApiMediaWithCropsModel | undefined) {
	const currentLanguage = getLocale();
	const altText = image?.properties?.altText;

	return (
		getLocalizedStringFromJson(
			typeof altText === "string" ? altText : undefined,
			currentLanguage,
		) ??
		image?.name ??
		""
	);
}

export function getAltTextFromString(image: string | undefined) {
	const currentLanguage = getLocale();

	return getLocalizedStringFromJson(image, currentLanguage) ?? "";
}
